import { gql } from '@apollo/client';
import Fragments from './fragments';

export const ENGINE_SCORING_GRID_HEADER_UPDATED = gql`
  subscription engineScoringGridHeaderUpdated {
    engineScoringGridHeaderUpdated {
      engineScoring {
        ...engineScoringGridItem
        partnerTypes {
          ...engineScoringXPartnerTypeItem
        }
        partnerBaseTypes {
          ...engineScoringGridXPartnerBaseTypeItem
        }
      }
    }
  }
  ${Fragments.engineScoringGridItem}
  ${Fragments.engineScoringXPartnerTypeItem}
  ${Fragments.engineScoringGridXPartnerBaseTypeItem}
`;

export const ENGINE_CLASSIFICATION_UPDATED = gql`
  subscription engineClassificationUpdated {
    engineClassificationUpdated {
      engineScoringId
    }
  }
`;

export const ENGINE_SCORING_KNOCKOUT_CRITERION_UPDATED = gql`
  subscription engineScoringKnockoutCriterionUpdated {
    engineScoringKnockoutCriterionUpdated {
      engineScoringId
    }
  }
`;

export const ENGINE_INTERVALS_UPDATED = gql`
  subscription engineIntervalsUpdated {
    engineIntervalsUpdated {
      engineScoringId
    }
  }
`;

export const ENGINE_RULES_UPDATED = gql`
  subscription engineRulesUpdated {
    engineRulesUpdated {
      engineScoringId
    }
  }
`;

export const ENGINE_EXTERNAL_SYSTEMS_UPDATED = gql`
  subscription engineExternalSystemsUpdated {
    engineExternalSystemsUpdated {
      engineScoringId
    }
  }
`;

export const ENGINE_EVALUATED_ATTRIBUTES_UPDATED = gql`
  subscription engineEvaluatedAttributesUpdated {
    engineEvaluatedAttributesUpdated {
      engineScoringId
    }
  }
`;

export const ENGINE_CLASSIFICATION_DELETED = gql`
  subscription engineScoringClassificationDeleted {
    engineScoringClassificationDeleted {
      engineScoringId
      engineScoringClassificationId
    }
  }
`;

export const ENGINE_KNOCKOUT_CRITERION_DELETED = gql`
  subscription engineScoringKnockoutCriterionDeleted {
    engineScoringKnockoutCriterionDeleted {
      engineScoringKnockoutCriteriaId
    }
  }
`;

export const TEST_SCORING_GRID_COMPLETED = gql`
  subscription testScoringGridCompleted {
    testScoringGridCompleted {
      scoringGridTestResult {
        ...scoringGridTestResultItem
        attributes {
          ...scoringGridTestResultAttributeItem
        }
      }
    }
  }
  ${Fragments.scoringGridTestResultItem}
  ${Fragments.scoringGridTestResultAttributeItem}
`;

export const TEST_SCORING_GRID_FAILED = gql`
  subscription testScoringGridFailed {
    testScoringGridFailed {
      engineScoringId
      errorMessage
    }
  }
`;

export const ENGINE_SCORING_DUPLICATED = gql`
  subscription engineScoringDuplicated {
    engineScoringDuplicated {
      engineScoringId
    }
  }
`;

export const ENGINE_SCORING_NEW_VERSION_CREATED = gql`
  subscription engineScoringNewVersionCreated {
    engineScoringNewVersionCreated {
      engineScoringId
    }
  }
`;
